<template>
  <div id="q-app" router-view="App">
    <router-view />
  </div>
</template>
<script>

import { site } from './services/sites'

import Vue from 'vue'

import _ from 'lodash'

import './fonticon/dist/icons.css'

import 'leaflet/dist/leaflet.css'

import 'leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css'

import { Icon } from 'leaflet'

delete Icon.Default.prototype._getIconUrl

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

import vueLuxon from 'vue-luxon'
import { DateTime } from 'luxon'
Vue.use(vueLuxon)

import VModal from 'vue-js-modal'
Vue.use(VModal)

Vue.filter('epochToISO', function (value) {
  if (!value) return ''
  return DateTime.fromMillis(value).toISO()
})

Vue.filter('_tpl', function (text, object) {
  var compiled = _.template(text)
  return compiled(object)
})

Vue.filter('upper', function (value) {
  if (!value) return ''
  return value.toString().toUpperCase()
})

Vue.filter('truncate', function (value, maxLength) {
  if (!value) return ''
  return value.toString().substring(0, maxLength)
})

import SingleReadingItem from 'components/SingleReadingItem'
Vue.component('single-reading-item', SingleReadingItem)

import TimeAgo from 'components/TimeAgo'
Vue.component('time-ago', TimeAgo)

import CopySpan from 'components/CopySpan'
Vue.component('copy-span', CopySpan)

import CopyValue from 'components/CopyValue'
Vue.component('copy-value', CopyValue)

import TimePeriod from 'components/TimePeriod'
Vue.component('time-period', TimePeriod)

import VueMobileDetection from 'vue-mobile-detection'
Vue.use(VueMobileDetection)

import DiagMarker from 'components/DiagMarker'
Vue.component('diag-marker', DiagMarker)

require('./services/echartsThemes.js')

import { mapGetters } from 'vuex'

import { pinia } from './store/index'

Vue.mixin({
  computed: {
    ...mapGetters('user', ['effectiveClientAcc', 'effectiveClientId'])
  },
  created () {
    this.$options.site = site
  },
  methods: {
    $get: _.get
  }
})

export default {
  name: 'App',
  pinia,
  data () {
    return {
    }
  },
  created () {
    // From: https://quasar.dev/vue-components/icon#1.-Support-for-custom-icon-library
    // Example of adding support for
    // <q-icon name="app:...." />
    // This includes support for all "icon" props
    // of Quasar components

    this.$q.iconMapFn = (iconName) => {
      // iconName is the content of QIcon "name" prop
      // your custom approach, the following
      // is just an example:
      if (iconName.startsWith('pethau:') === true) {
        // we strip the "pethau:" part
        const name = iconName.substring(7)

        return {
          cls: 'icon icon-' + name
        }
      }

      // when we don't return anything from our
      // iconMapFn, the default Quasar icon mapping
      // takes over
    }
  }

}
</script>
